var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaekwondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4,
    cy: 21.9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3,23.4c-1-1-2.3-1.5-3.6-1.5c-1.3,0-2.6,0.5-3.6,1.5L61.7,73.7v57.4c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V78 l47.3-47.3c1-1,1.5-2.3,1.5-3.6C120.9,25.7,120.4,24.4,119.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,38.8h8.5c1.3,0,2.6-0.5,3.6-1.5c1-1,1.5-2.3,1.5-3.6V12.9c0-1.4-0.6-2.7-1.5-3.6c-0.9-0.9-2.2-1.5-3.6-1.5 c-1.4,0-2.7,0.6-3.6,1.5c-0.9,0.9-1.5,2.2-1.5,3.6v15.7H47.2c-1.4,0-2.7,0.6-3.6,1.5L30.8,42.8c-0.9,0.9-1.5,2.2-1.5,3.6v20 c0,1.4,0.6,2.7,1.5,3.6c0.9,0.9,2.2,1.5,3.6,1.5h20c1.4,0,2.7-0.6,3.6-1.5l16.4-16.4L59.6,38.8z M39.6,61.3v-9.7l9.7,9.7H39.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaekwondo);
export default __webpack_public_path__ + "static/media/taekwondo.12240b05d83b08bc358a4a724b9619b6.svg";
export { ForwardRef as ReactComponent };